// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"8b14e9d7","213":"9e7bde2b","475":"ceb7bbcb","580":"874efd91","591":"f0938731","747":"9a57d74c"}[chunkId] + ".chunk.js";
};